import { UserType } from '@context/user'
import { loadTextosBundle } from '@proxies/loadTextosBundle'
import { useAppStore } from '@store'
import { resolveCulture } from '@utils/i18nLocale'
import React, { useEffect } from 'react'

export default function useUserLanguage(
  userState: [UserType, React.Dispatch<React.SetStateAction<UserType>>],
) {
  const setTextos = useAppStore.use.setTextos()
  const isUserLogged = window.localStorage.getItem('isUserLogged') === 'true'

  useEffect(() => {
    if (!isUserLogged) return

    const culture = resolveCulture(userState[0].idiomaCultura)

    loadTextosBundle(culture)
      .then((bundle) => {
        setTextos({ idioma: bundle.idioma, textos: bundle.textos })
        useAppStore.getState().setIdiomaCultura(bundle.resolvedCulture)
      })
      .catch((error) => {
        console.error('[i18n] Error cargando idioma del usuario:', error)
      })
  }, [userState[0].idIdioma, isUserLogged])
}
